module.exports = __webpack_public_path__ + "static/media/ap-swiper-pc-4.b8f0f5e7.png";